import React from "react";

const ErrorMessage = ({ condition, message }) => {
  return <>
    {condition && <div style={{ color: "#dc3545", fontSize: "80%" }}>{message.charAt(0).toUpperCase() + message.slice(1)}</div>}
  </>
};

export default ErrorMessage;